import { type ChangeEvent } from 'react'

interface NicknameStepProps {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  maxLength: number
  error?: string
}

export function NicknameStep({ value, onChange, maxLength, error }: NicknameStepProps) {
  return (
    <div className='space-y-4'>
      <div className='space-y-2 mb-6 text-center'>
        <h2 className='text-[24px] font-bold text-[#020202]'>너를 어떻게 불러주면 좋겠어?</h2>
        <p className='text-[14px] text-[#7D7D7D]'>마음껏 정해봐! 나중에 수정할 수도 있어.</p>
      </div>
      <div>
        <div className='relative w-full max-w-[280px] mx-auto'>
          <input
            type='text'
            placeholder='예) 크림빵'
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            className='w-full text-center text-[20px] font-[500] p-3 rounded-2xl bg-white/70 backdrop-blur-sm border-2 border-[#FFA236]/20 focus:border-[#FFA236] focus:outline-none focus:ring-2 focus:ring-[#FFA236]/50 transition-all duration-300 placeholder:text-[16px] placeholder:text-gray-400'
            required
          />
          <div className='absolute right-2 top-1/2 -translate-y-1/2 text-sm text-amber-500 font-medium bg-white/80 py-1 px-1 rounded-full'>
            {value.length}/{maxLength}
          </div>
        </div>
        <div className='mt-2 px-8 h-4 text-center text-red-500 text-sm'>{error && <p>{error}</p>}</div>
      </div>
    </div>
  )
}
